import styled from '@mui/styled-engine'
import { Box, InputBase, Typography } from '@mui/material'

export const RawControlInput = styled(InputBase)(({ theme, focus, error, disabled }) => ({
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  width: 120,
  height: 32,
  borderRadius: 4,
  color: disabled ? theme.palette.grey[500] : theme.palette.grey[800],
  padding: '3px 8px 0',
  border: error
    ? `2px solid ${theme.palette.error.main}`
    : focus
    ? `2px solid ${theme.palette.primary.main}`
    : '1px solid #DAE0E7',
  backgroundColor: disabled ? '#FAFAFA' : '#F6F6F6',
  position: 'relative',
  zIndex: 0,
  cursor: disabled ? 'not-allowed' : 'text',
  '&.Mui-disabled': {
    color: theme.palette.grey[500],
  }
}))

export const OverLabel = styled(Typography)(({ theme, isaside }) => ({
  top: '50%',
  left: isaside ? 12 : '50%',
  transform: isaside ? 'translateY(-50%)' : 'translate(-50%, -50%)',
  position: 'absolute',
  transition: 'all 0.2s ease-out',
  textTransform: 'uppercase',
  fontWeight: 600,
  fontSize: 10,
  lineHeight: 3.2,
  color: theme.palette.grey[800],
  pointerEvents: 'none',
  zIndex: 1,
}))

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  marginBottom: theme.spacing(2),
  gap: theme.spacing(1),
}))

export const FieldWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
})

export const ErrorText = styled(Typography)(({ theme }) => ({
  fontSize: 10,
  color: theme.palette.error.main,
  marginTop: 2,
  lineHeight: 1.2,
  minHeight: 12,
}))